import { createReducer, on } from '@ngrx/store';
import { AccountNotification } from '@smmof/entity';
import { AccountNotificationsActions } from '../actions/notifications.actions';

export interface AccountNotificationsState {
  notifications: AccountNotification[];
  loading: boolean;
  error: any;
}

export const initialAccountNotificationsState: AccountNotificationsState = {
  notifications: [],
  loading: false,
  error: null,
};

export const accountNotificationsReducer = createReducer(
  initialAccountNotificationsState,

  // Загрузка уведомлений
  on(AccountNotificationsActions.loadNotifications, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AccountNotificationsActions.loadNotificationsSuccess, (state, { notifications }) => ({
    ...state,
    notifications: notifications,
    loading: false,
  })),
  on(AccountNotificationsActions.loadNotificationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  // Добавление уведомления
  on(AccountNotificationsActions.addNotificationSuccess, (state, { notification }) => ({
    ...state,
    notifications: [...state.notifications, notification],
  })),

  // Обновление уведомления
  on(AccountNotificationsActions.updateNotificationSuccess, (state, { notification }) => ({
    ...state,
    notifications: state.notifications.map((n) =>
      n.id === notification.id ? notification : n
    ),
  })),

  // Удаление уведомления
  on(AccountNotificationsActions.deleteNotificationSuccess, (state, { id }) => ({
    ...state,
    notifications: state.notifications.filter((n) => n.id !== id),
  })),

  // Пометить все как прочитанные
  on(AccountNotificationsActions.markAllAsReadSuccess, (state) => ({
    ...state,
    notifications: state.notifications.map((n) => ({ ...n, read: true })),
  })),

  // Получение уведомления через WebSocket
  on(AccountNotificationsActions.receiveWebSocketNotification, (state, { notification }) => ({
    ...state,
    notifications: [notification, ...state.notifications],
  })),

  // Обработка ошибок для других действий
  on(
    AccountNotificationsActions.addNotificationFailure,
    AccountNotificationsActions.updateNotificationFailure,
    AccountNotificationsActions.deleteNotificationFailure,
    AccountNotificationsActions.markAllAsReadFailure,
    (state, { error }) => ({
      ...state,
      error: error,
    })
  )
);
